export default __webpack_public_path__ + "static/media/x-blue.5868f37b.svg";